import { Mongo } from 'meteor/mongo';

export const NumInvalidListings = new Mongo.Collection<{ _id: string, count: number }>('numInvalidListings');
export const NotificationsCount = new Mongo.Collection<{ _id: string, count: number }>('_notificationsCount');